
angular
  .module('app')
  .filter('shortText', shortText);

function shortText($filter) {
  return function (text, length) {
    if (!text) {
      return '';
    }

    if (!angular.isString(text)) {
      return text.toString();
    }

    if (!angular.isNumber(length)) {
      return text;
    }

    var customEnd = '<hr class="ng-scope"/>';
    if (text.indexOf(customEnd) !== -1) {
      text = text.substr(0, text.indexOf(customEnd));

      return $filter('shortText')(text, length);
    }

    text = angular.element('<div>' + text + '</div>').text();

    if (length >= 0 && text.length >= length) {
      text = text.substr(0, length);

      var lastWordIndex = text.lastIndexOf(' ');
      text = text.substr(0, lastWordIndex) + '...';
    }

    return text;
  };
}
